import { DataObject } from "../../DataObject";
import { TimerCore } from "./TimerCore";
import { Time } from "@/lib/Time";
import { Checker } from "@/lib/Checker";

export class Timer extends DataObject {
  _INTERVAL_TIME = 500;
  _timerCore;

  constructor(path) {
    super({
      data: {
        accumulator: 0,
        userId: "",
        projectId: "",
        startTimestamp: null,
        creationTimestamp: null
      },
      path,
      validator: data => {
        const {
          accumulator,
          userId,
          projectId,
          startTimestamp,
          creationTimestamp
        } = data;
        Checker.checkTypes(accumulator, ["number"], "accumulator");
        Checker.checkTypes(userId, ["string"], "userId");
        Checker.checkTypes(projectId, ["string"], "projectId");
        Checker.checkTypes(startTimestamp, ["null", Date], "startTimestamp");
        Checker.checkTypes(
          creationTimestamp,
          ["null", Date],
          "creationTimestamp"
        );
      }
    });
  }

  updateData(data) {
    super.updateData(data);
    let timecore = new TimerCore();
    timecore.setData(data);
    this._timerCore = timecore;
  }

  async start() {
    if (this.status !== "RUNNING") {
      this._timerCore.start();
      super.updateData(this._timerCore.data);
      await this.save();
    }
  }

  async pause() {
    if (this.status == "RUNNING") {
      this._timerCore.pause();
      super.updateData(this._timerCore.data);
      await this.save();
    }
  }

  async clear() {
    this._timerCore.clear();
    super.updateData(this._timerCore.data);
    await this.save();
  }

  async stop() {
    await this.clear();
  }

  get elapsedTime() {
    return this._timerCore.elapsedTime;
  }

  get status() {
    return this._timerCore.status;
  }

  exportRecordData() {
    return {
      creationTimestamp: this._timerCore.data.creationTimestamp,
      endTimestamp: Time.date.getNow(),
      value: this._timerCore.elapsedTime
    };
  }
}
